import { faComputer, faLaptop, faDesktop } from '@fortawesome/free-solid-svg-icons';

const icons = [
    {
        type: "PC/Desktop",
        icon: faComputer,
        category: 'Primary'
    },
    {
        type: "Laptop",
        icon: faLaptop,
        category: 'Primary'
    },
    {
        type: "Monitor",
        icon: faDesktop,
        category: 'Secondary'
    },
]

export default icons;